import { useTranslation } from "react-i18next";
import "./sp-report.scss";
import { Breadcrumb, Button, Col, Form, Input, Row, Table } from "antd";
import { _adr } from "../../../../address";
import { ExportOutlined, HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import { complexDigitToman, convertToGregorian, convertToJalaliWithoutTime, isEmpty, validateInput } from "../../../../tools/tools";
import { Excel } from "antd-table-saveas-excel";
import { NotFound } from "../../../../sources/svg/svg";
import { useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import Loading from "../../../auxiliary/loader/loading";
import { useLayout } from "../../../layouts/layout";
import PrintDocument from "../../print/printDocument";
import { useSelector } from "react-redux";
const SPReportList = () => {
  const [t] = useTranslation("global");
  const { querySPPurchaseDealerByDate, querySPPurchaseVProfileDealerById } = useDealer();

  const formData = useSelector((state) => state);

  const { setLayout } = useLayout();

  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(-1);

  const [frmSearch] = Form.useForm();

  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const cTable = [
    {
      title: "نام کاربری",
      dataIndex: "username",
      key: "username",
      width: 150,
    },
    {
      title: "شماره",
      dataIndex: "msisdn",
      key: "msisdn",
      width: 150,
    },
    {
      title: "شماره کیت",
      dataIndex: "kit",
      key: "kit",
      width: 150,
    },
    {
      title: "عنوان بسته",
      dataIndex: "packageName",
      key: "packageName",
      width: 150,
    },
    {
      title: "قیمت (تومان)",
      dataIndex: "price",
      key: "price",
      width: 150,
    },
    {
      title: "سودفروش (تومان)",
      dataIndex: "commission",
      key: "commission",
      width: 150,
    },
    {
      title: "تاریخ خرید",
      dataIndex: "purchaseDate",
      key: "purchaseDate",
      width: 150,
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
      width: 150,
    },
    {
      title: "چاپ سند",
      dataIndex: "printdoc",
      key: "printdoc",
      width: 150,
    },
  ];
  const [bTable, setBTable] = useState([]);
  const [tTable, setTTable] = useState([]);

  useEffect(() => {
    const callServices = async () => {
      try {
        let valid = await frmSearch.validateFields();
        if (valid) {
          let value = {
            duringdate: frmSearch.getFieldValue("duringdate"),
          };

          handleSearch(value);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (isActive) {
      callServices();
    }
  }, [currentPage]);

  const handleSearch = async (value) => {
    try {
      setIsLoading(true);
      let payload = {
        startDate: convertToGregorian(value?.duringdate[0].format("YYYY-MM-DD"), "-", "-"),
        endDate: convertToGregorian(value?.duringdate[1].format("YYYY-MM-DD"), "-", "-"),
        search: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: currentPage === 0 ? 0 : currentPage - 1,
          totalrowcount: 0,
        },
      };
      let response = await querySPPurchaseDealerByDate(payload);
      if (response) {
        setIsActive(true);
        setBTable(
          response?.Result?.map((item, key) => ({
            key: key,
            username: item.username,
            msisdn: item.msisdn,
            kit: item.iccid.slice(9, 19),
            packageName: item.packagename,
            price: complexDigitToman(item.purchaseamount),
            commission: complexDigitToman(item.packageCommssion),
            purchaseDate: convertToJalaliWithoutTime(item.purchasedate),
            status: (
              <>
                <span>{item.purchasestate}</span>
              </>
            ),
            printdoc: (
              <>
                <Button onClick={handlePrint} data-id={item.purchaseproductid} className="btn-normal ">
                  چاپ سند
                </Button>
              </>
            ),
          })),
        );
        setTTable(
          response?.Result?.map((item, key) => ({
            key: key,
            username: item.username,
            msisdn: item.msisdn,
            kit: item.iccid.slice(9, 19),
            packageName: item.packagename,
            price: complexDigitToman(item.purchaseamount),
            commission: complexDigitToman(item.packageCommssion),
            purchaseDate: convertToJalaliWithoutTime(item.purchasedate),
            status: (
              <>
                <span>{item.purchasestate}</span>
              </>
            ),
          })),
        );
        setTotalRecord(response?.searchconfigmodel?.totalrowcount);
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
  const handleExport = () => {
    const excel = new Excel();
    let tempTable = bTable.map((item) => {
      return { ...item, status: item.status.props.children.props.children };
    });
    excel.addSheet("گزارش خرید سیم‌کارت").addColumns(cTable).addDataSource(tempTable, { str2Percent: true }).saveAs("export-simcard-purchases.xlsx");
  };
  const handleSearchOnTable = (e) => {
    if (!isEmpty(e.target.value)) {
      let temp = tTable.filter((o) => {
        return Object.keys(o).some((k) => {
          return o[k]?.toString()?.toLowerCase()?.includes(e.target.value);
        });
      });
      setBTable(temp);
    } else {
      setBTable(tTable);
    }
  };

  const handlePrint = async (e) => {
    if (e?.currentTarget?.dataset?.id !== null) {
      setIsLoading(true);
      let response = await querySPPurchaseVProfileDealerById(e?.currentTarget?.dataset?.id);
      if (response) {
        var print = {
          spbundle: {
            bundleType: response?.inT_MSISDNStatusType,
          },
          spMsisdn: [{ msisdn: response?.inT_MSISDN }],
          spKit: response?.stR_ICCID?.slice(9, 19),
          profile: {
            fname: response?.stR_FName,
            lname: response?.stR_LName,
            fathername: response?.stR_FatherName,
            certno: response?.stR_CertNo,
            birthdate: response?.dtE_BirthDate,
            txtCountry: "",
            gender: response?.inT_Gender,
            email: response?.stR_Email,
            postalcode: response?.address?.stR_PostalCode,
            txtProvince: response?.province?.stR_ProvinceName,
            txtCity: response?.city?.stR_CityName,
            mainstreet: response?.address?.stR_MainStreet,
            buildingno: response?.address?.stR_BuildingNo,
            floor: response?.address?.stR_Floor,
          },
          branchcode: formData?.another?._currentUser?.branchcode,
        };
        setLayout(
          <>
            <PrintDocument print={{ ...print }} />
          </>,
        );
        setTimeout(() => {
          window.print();
        }, 1000);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    }
  };
  return (
    <div className="container-main container-sp">
      <div className="g-hold-title-of-page">
        <Breadcrumb
          className="breadcrumbs"
          items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.report.title") }]}
        />

        <div className="title-page">
          <h3>{t("simcardpurchase.report.title")}</h3>
          <p></p>
        </div>
      </div>
      <div className="g-layout-content">
        <Content className="g-layout-main sp-container">
          <div className="sp-report-list-container">
            <div className="g-layout-report">
              <div className="g-search-area">
                <Form form={frmSearch} onFinish={handleSearch} layout="vertical">
                  <Row gutter={30}>
                    <Col>
                      <JalaliLocaleListener />
                      <Form.Item
                        name="duringdate"
                        className="input-normal"
                        label="انتخاب تاریخ"
                        rules={[validateInput({ t: t, validate: true, typeOfValue: "array" })]}
                      >
                        <DatePickerJalali.RangePicker format={"YYYY/MM/DD"} />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item label="&nbsp;">
                        <Button htmlType="submit" className="btn-normal btn-green">
                          جستجو
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
              {isActive !== -1 && (
                <div className="holder-table">
                  <div className="holder-top-table">
                    <div className="holder-search">
                      <Form layout="vertical">
                        <Row gutter={16}>
                          <Col span={6} xl={6} lg={10} md={15} xs={24} sm={24}>
                            <Form.Item className="input-normal" label="جستجو">
                              <Input placeholder="جستجو" allowClear onChange={handleSearchOnTable} suffix={<i className="icon-search"></i>} />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                    <div className="holder-button">
                      <br />
                      <Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
                        {" "}
                        خروجی اکسل{" "}
                      </Button>
                    </div>
                  </div>
                  <Table
                    className="tbl-normal"
                    columns={cTable}
                    locale={{
                      emptyText: (
                        <>
                          <NotFound text={"رکوردی یافت نشد."} />
                        </>
                      ),
                    }}
                    pagination={{
                      className: "page-pagination",
                      // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
                      onChange: (page) => {
                        setCurrentPage(page);
                      },
                      pageSize: 10,
                      align: "start",
                      current: currentPage === 0 ? 1 : currentPage,
                      total: totalRecord,
                      showSizeChanger: false,
                    }}
                    scroll={{ y: "100%" }}
                    dataSource={bTable}
                  ></Table>
                </div>
              )}
            </div>
          </div>
        </Content>
        <Loading isOpen={isLoading} />
      </div>
    </div>
  );
};

export default SPReportList;
